import * as React from "react";

// import * as cx from "classnames";
import * as shortid from "shortid";
import RadioInput from "@tunnel-components/@sharded/widgets/forms/input/radio/custom/component";
import BoxGrid from "@tunnel-components/@sharded/widgets/box/custom/component";
import * as i18next from "i18next"; // traduction

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const { /*item  onSubmit*/ checked, onChecked, disabled, style } = props;
  /**
   * @constant
   * @name seaConfirmation
   * @type string[]
   */
  const seaConfirmation: string[] = [
    i18next.t("incidents averés"),
    i18next.t("fausses alarmes"),
    i18next.t("Tous les incidents qualifiés"),
    i18next.t("Tous les incidents"),
    i18next.t("Aucun incident"),
  ];
  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */

  return (
    <li className="homeDisplay" key={shortid.generate()}>
      <BoxGrid
        title={i18next.t("CONNEXION SAE")}
        classNames="boderShadow"
        error={true}
        BtnTextSpan={i18next.t("enregistrer")}
      >
        <div className="boxGridContentInsider">
          <div className="boxGridContentText">
            <span>{i18next.t("confirmation d'envoi SAE pour")} :</span>
          </div>
          <div className="boxGridContentText">
            {seaConfirmation.map((Elem: any, index: any) => {
              return (
                <RadioInput
                  style={style}
                  key={index}
                  name="seaRadio"
                  id={`seaRadioBtn-${index}`}
                  checked={checked[index]}
                  onChecked={onChecked(index)}
                  disabled={disabled}
                  label={Elem}
                />
              );
            })}
          </div>
        </div>
      </BoxGrid>
    </li>
  );
};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  checked?: any;
  onChecked?: any;
  disabled?: any;
  onSubmit?: any;
  style?: any;
}
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/@widgets/display/sae/component.tsx